import {
  doc,
  setDoc,
  getDoc,
  Firestore,
  getFirestore,
} from "@angular/fire/firestore";
import {
  TenantInfoModel,
  TenantUserModel,
} from "src/app/store/models/tenant.model";
import { BehaviorSubject } from "rxjs";
import { getApp } from "@angular/fire/app";
import { inject, Injectable } from "@angular/core";
import { StorageService } from "../storage-service/storage.service";
import { getStorage, FirebaseStorage } from "@angular/fire/storage";

@Injectable({
  providedIn: "root",
})
export class TenantService {
  public dbName = new BehaviorSubject<string>("");
  public domainName = new BehaviorSubject<string>("");
  public realtimeDB = new BehaviorSubject<string>("");
  // private _storage: Storage | null = null;
  private readonly storage = inject(StorageService);

  constructor() {}

  async get(key: string): Promise<any> {
    return this.storage?.get(key);
  }

  async getMyDb(): Promise<Firestore> {
    const dbName = await this.get("dbName");
    const app = getApp();

    if (dbName !== "(default)") {
      return getFirestore(app, dbName);
    }
    return getFirestore(app);
  }

  async getUserStorage(name: string | null = null): Promise<FirebaseStorage> {
    const app = getApp();
    const bucketName = name ? name : await this.get("bucketName");
    return getStorage(app, `gs://${bucketName}`);
  }

  async createFireStoreInstance(email: string): Promise<boolean> {
    const app = getApp();
    const defaultDb = getFirestore(app);

    try {
      const userSnap = await getDoc(doc(defaultDb, "tenant_users", email));

      if (!userSnap?.exists()) return false;

      const user = userSnap.data() as TenantUserModel;

      const tenantSnap = await getDoc(
        doc(defaultDb, "tenant_configuration", user.tenant),
      );

      if (!tenantSnap?.exists()) return false;

      const tenantInfo = tenantSnap.data() as TenantInfoModel;

      const dbName = tenantInfo?.databaseId;
      const realtimeDB = tenantInfo?.realtimeDB;
      const bucketName = tenantInfo?.bucketName ?? "";

      if (!dbName) return false;

      this.storage?.set("dbName", dbName);
      this.storage?.set("tenantInfo", tenantInfo);
      this.storage?.set("realtimeDB", realtimeDB);
      this.storage?.set("bucketName", bucketName);

      return true;
    } catch (error) {
      return false;
    }
  }

  async getTenantConfiguration(email: string): Promise<boolean> {
    const app = getApp();
    const defaultDb = getFirestore(app);

    try {
      const userSnap = await getDoc(doc(defaultDb, "tenant_users", email));
      if (!userSnap?.exists()) return false;

      const user = userSnap.data() as TenantUserModel;

      const tenantSnap = await getDoc(
        doc(defaultDb, "tenant_configuration", user.tenant),
      );
      if (!tenantSnap?.exists()) return false;

      const tenantInfo = tenantSnap.data() as TenantInfoModel;
      if (!tenantInfo?.databaseId) return false;

      this.storage?.set("tenantInfo", tenantInfo);

      return true;
    } catch {
      return false;
    }
  }

  async createTenantUser(email: string): Promise<boolean> {
    try {
      const app = getApp();
      const defaultDb = getFirestore(app);

      const tenant = await this.storage?.get("dbName");
      const userData = { email: email, tenant: tenant };

      const tenantUserRef = doc(defaultDb, "tenant_users", email);
      await setDoc(tenantUserRef, userData);
      return true;
    } catch (error) {
      return false;
    }
  }
}
